"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivityList = void 0;
var TOP_LIST_ITEMS = 4;
var ActivityList = /** @class */ (function (_super) {
    __extends(ActivityList, _super);
    function ActivityList() {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        var _this = _super.apply(this, items) || this;
        _this.getSortedList = function () {
            var items = __spreadArrays(_this.getOrderByCustomOrder.apply(_this, _this.getFeatured().getWithCustomOrder()), _this.getNewestFirst.apply(_this, _this.getFeatured().getWithoutCustomOrder()), _this.getOrderByCustomOrder.apply(_this, _this.getNonFeatured().getWithCustomOrder()), _this.getNewestFirst.apply(_this, _this.getNonFeatured().getWithoutCustomOrder()));
            return new (ActivityList.bind.apply(ActivityList, __spreadArrays([void 0], items)))();
        };
        _this.getFeatured = function () { return new (ActivityList.bind.apply(ActivityList, __spreadArrays([void 0], _this.filter(function (x) { return x.isFeatured; }))))(); };
        _this.getNonFeatured = function () { return new (ActivityList.bind.apply(ActivityList, __spreadArrays([void 0], _this.filter(function (x) { return !x.isFeatured; }))))(); };
        _this.getWithCustomOrder = function () { return new (ActivityList.bind.apply(ActivityList, __spreadArrays([void 0], _this.filter(function (x) { return x.customOrder > 0; }))))(); };
        _this.getWithoutCustomOrder = function () { return new (ActivityList.bind.apply(ActivityList, __spreadArrays([void 0], _this.filter(function (x) { return x.customOrder < 1; }))))(); };
        _this.getOrderByCustomOrder = function () {
            var items = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                items[_i] = arguments[_i];
            }
            return new (ActivityList.bind.apply(ActivityList, __spreadArrays([void 0], items.sort(function (x, y) { return (x.customOrder > y.customOrder ? -1 : 1); }))))();
        };
        _this.getNewestFirst = function () {
            var items = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                items[_i] = arguments[_i];
            }
            return new (ActivityList.bind.apply(ActivityList, __spreadArrays([void 0], items.sort(function (x, y) {
                var dateStartX = !!x.date_start ? x.date_start : 0;
                var dateStartY = !!y.date_start ? y.date_start : 0;
                return dateStartX > dateStartY ? -1 : 1;
            }))))();
        };
        _this.getDateStartSorted = function () {
            return _this.sort(function (x, y) {
                var dateStartX = !!x.date_start ? x.date_start : 0;
                var dateStartY = !!y.date_start ? y.date_start : 0;
                return dateStartX > dateStartY ? -1 : 1;
            });
        };
        /**
         * @deprecated
         */
        _this.isFeatured = function () { return _this.find(function (x) { return x.isFeatured; }); };
        /**
         * @deprecated
         */
        _this.getActivitiesListSorted = function () {
            var activityList = new ActivityList();
            if (_this.length > 0) {
                _this.filter(function (x) { return x.isFeatured; })
                    .slice(1)
                    .forEach(function (x) { return activityList.push(x); });
                _this.filter(function (x) { return !x.isFeatured; }).forEach(function (x) { return activityList.push(x); });
            }
            return activityList;
        };
        /**
         * @deprecated
         */
        _this.isScanTicket = function () {
            var activityList = new ActivityList();
            _this.filter(function (x) { return x.isScanTicket; }).forEach(function (x) { return activityList.push(x); });
            return activityList;
        };
        /**
         * @deprecated
         */
        _this.topSection = function () {
            var activityList = new ActivityList();
            var thisFeaturedActivity = _this.isFeatured();
            _this.filter(function (x) { return !x.isScanTicket && !x.isMobileAppSignInBonus && !x.isWebOnly && (!thisFeaturedActivity || thisFeaturedActivity.id !== x.id); })
                .filter(function (_x, index) { return index < TOP_LIST_ITEMS; })
                .forEach(function (x) { return activityList.push(x); });
            return activityList;
        };
        /**
         * @deprecated
         */
        _this.bottomSection = function () {
            var activityList = new ActivityList();
            var thisFeaturedActivity = _this.isFeatured();
            _this.filter(function (x) { return !x.isScanTicket && !x.isMobileAppSignInBonus && !x.isWebOnly && (!thisFeaturedActivity || thisFeaturedActivity.id !== x.id); })
                .filter(function (_x, index) { return index >= TOP_LIST_ITEMS; })
                .forEach(function (x) { return activityList.push(x); });
            return activityList;
        };
        _this.getMobileList = function () { return new (ActivityList.bind.apply(ActivityList, __spreadArrays([void 0], _this.filter(function (x) { return x.isVisibleOnMobileListPage; }))))().getSortedList(); };
        _this.getWebList = function () { return new (ActivityList.bind.apply(ActivityList, __spreadArrays([void 0], _this.filter(function (x) { return x.isVisibleOnWebListPage; }))))().getSortedList(); };
        return _this;
    }
    ActivityList.getCombinedSortedList = function (activityList, other) {
        if (other === void 0) { other = []; }
        var combinedList = __spreadArrays(activityList, other);
        // make them distinct by activity id.
        var list = Array.from(new Set(combinedList.map(function (x) { return x.id; })))
            .map(function (activityId) { return combinedList.find(function (x) { return x.id === activityId; }); })
            .filter(function (x) { return !!x; });
        return new (ActivityList.bind.apply(ActivityList, __spreadArrays([void 0], list)))().getSortedList();
    };
    return ActivityList;
}(Array));
exports.ActivityList = ActivityList;
//# sourceMappingURL=ActivityList.js.map